/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../sub2/common';
import './localized_addon';
import '../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "addons": {
        "nested": {
          "data": {
            "nested": {
              "AddonStatusForSeller": {
                "fields": {
                  "addonId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "installed": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "availableAtCurrentLocation": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "subscriptionStatus": {
                    "type": "squareup.sub2.common.SubscriptionStatus",
                    "id": 4,
                    "rule": "optional"
                  },
                  "installedAddonPaidStatus": {
                    "type": "squareup.addons.data.LocalizedAddon.InstalledAddonPaidStatus",
                    "id": 5,
                    "rule": "optional"
                  },
                  "canBeUninstalled": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "addonStatusForDevice": {
                    "type": "squareup.addons.data.AddonStatusForDevice",
                    "id": 7,
                    "rule": "optional"
                  },
                  "currentPlanId": {
                    "type": "squareup.addons.data.AddonSubscriptionPlan.AddonSubscriptionPlanId",
                    "id": 8,
                    "rule": "optional"
                  },
                  "newlyAdded": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "availablePlans": {
                    "type": "squareup.addons.data.AddonSubscriptionPlan.AddonSubscriptionPlanId",
                    "id": 10,
                    "rule": "repeated"
                  },
                  "availableFreeTrials": {
                    "type": "squareup.addons.data.AddonAvailableTrial",
                    "id": 11,
                    "rule": "repeated"
                  },
                  "activeFreeTrial": {
                    "type": "squareup.addons.data.AddonActiveTrial",
                    "id": 12,
                    "rule": "optional"
                  },
                  "canBeInstalled": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  }
                }
              },
              "AddonStatusForDevice": {
                "fields": {
                  "isEnabled": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "calculatedAvailabilityForDevice": {
                    "type": "squareup.addons.data.LocalizedAddon.SellerSpecificDetails.CalculatedAvailabilityForDevice",
                    "id": 2,
                    "rule": "optional"
                  },
                  "supportedOnDevice": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "AddonAvailableTrial": {
                "fields": {
                  "planId": {
                    "type": "squareup.addons.data.AddonSubscriptionPlan.AddonSubscriptionPlanId",
                    "id": 1,
                    "rule": "optional"
                  },
                  "trialDays": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "AddonActiveTrial": {
                "fields": {
                  "planId": {
                    "type": "squareup.addons.data.AddonSubscriptionPlan.AddonSubscriptionPlanId",
                    "id": 1,
                    "rule": "optional"
                  },
                  "endAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.AddonStatusForSeller && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.AddonStatusForDevice && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.AddonAvailableTrial && !$root.nested?.squareup?.nested?.addons?.nested?.data?.nested?.AddonActiveTrial) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE AddonStatusForSeller @ squareup/addons/data/addon_status_for_seller.proto at 13:1
 */
export const AddonStatusForSeller = $root.lookupType('squareup.addons.data.AddonStatusForSeller');
fixType(AddonStatusForSeller, {
  addonId: {
    notEmpty: true
  },
  installed: {
    required: true
  },
  availableAtCurrentLocation: {
    required: true
  },
  newlyAdded: {
    required: true
  }
});
Builder.createAndAttachToType(AddonStatusForSeller);
/**
 * SOURCE AddonStatusForDevice @ squareup/addons/data/addon_status_for_seller.proto at 71:1
 */
export const AddonStatusForDevice = $root.lookupType('squareup.addons.data.AddonStatusForDevice');
fixType(AddonStatusForDevice);
Builder.createAndAttachToType(AddonStatusForDevice);
/**
 * SOURCE AddonAvailableTrial @ squareup/addons/data/addon_status_for_seller.proto at 91:1
 */
export const AddonAvailableTrial = $root.lookupType('squareup.addons.data.AddonAvailableTrial');
fixType(AddonAvailableTrial, {
  planId: {
    required: true
  },
  trialDays: {
    required: true
  }
});
Builder.createAndAttachToType(AddonAvailableTrial);
/**
 * SOURCE AddonActiveTrial @ squareup/addons/data/addon_status_for_seller.proto at 102:1
 */
export const AddonActiveTrial = $root.lookupType('squareup.addons.data.AddonActiveTrial');
fixType(AddonActiveTrial, {
  planId: {
    required: true
  },
  endAt: {
    required: true
  }
});
Builder.createAndAttachToType(AddonActiveTrial);